<div class="dialog-content-wrapper">
  <mat-toolbar class="mat-accent m-0">
    <mat-toolbar-row class="flex flex-row justify-between items-center flex-1">
      <span i18n class="title dialog-title">Оплата через Wooppay</span>
      <button mat-button class="mat-icon-button" (click)="dialogRef.close(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-4 pb-0 m-0" fusePerfectScrollbar>
    <ng-container>
      <p i18n class="mat-body-1"
        >Введите сумму, которую вы хотите оплатить. После нажатия кнопки "Перейти к оплате" вы будете перенаправлены на
        сайт платёжной системы Wooppay для совершения платежа.</p
      >
      <p class="mat-body-1 warning-text" *ngIf="paymentFeeMsg !== ''">{{ paymentFeeMsg }}</p>

      <form #formWooppay class="flex flex-col justify-around">
        <mat-form-field class="flex-1">
          <input i18n-placeholder matInput name="amount" [formControl]="amount" required placeholder="Сумма" />
          <span matSuffix>{{ currentCurrencySign }}</span>
          <mat-error *ngIf="amount.invalid">{{ getErrorMessage() }}</mat-error>
        </mat-form-field>
      </form>
    </ng-container>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button
      i18n
      type="button"
      mat-raised-button
      class="mat-accent mr-4"
      [disabled]="amount.invalid"
      (click)="payWooppayClick()"
      >ПЕРЕЙТИ К ОПЛАТЕ</button
    >
    <button i18n type="button" mat-button (click)="dialogRef.close(false)">ОТМЕНА</button>
  </div>
</div>
